import { render, staticRenderFns } from "./DetailLG.vue?vue&type=template&id=787816ad&scoped=true"
import script from "./DetailLG.vue?vue&type=script&lang=js"
export * from "./DetailLG.vue?vue&type=script&lang=js"
import style0 from "./DetailLG.vue?vue&type=style&index=0&id=787816ad&prod&lang=css"
import style1 from "./DetailLG.vue?vue&type=style&index=1&id=787816ad&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787816ad",
  null
  
)

export default component.exports